export const SET_PHOTO_TO_UPLOAD = 'SET_PHOTO_TO_UPLOAD'
export const CLEAR_PHOTO_TO_UPLOAD = 'CLEAR_PHOTO_TO_UPLOAD'

function setPhotoToUpload(state, photoBase64, rootType, rootId) {
    return {
        ...state,
        photoBase64,
        rootType,
        rootId,
    }
}

function clearPhotoToUpload(state) {
    return {
        ...state,
        photoBase64: null,
        rootType: null,
        rootId: 0,
    }
}

/**
 * Reducer for on boarding
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_PHOTO_TO_UPLOAD: return setPhotoToUpload(state, action.photoBase64, action.rootType, action.rootId)
        case CLEAR_PHOTO_TO_UPLOAD: return clearPhotoToUpload(state)
        default: return state
    }
}
